import styled, { css } from 'styled-components';

const subColor = 'black';
const mainColor = 'white';

const shrinkLabelStyles = css`
  top: -20px;
  font-size: 15px;
  font-weight: bold;
  color: ${mainColor};
  @media screen and (max-width: 600px) {
    font-size: 8px;
  }
`;

export const GroupContainer = styled.div`
  position: relative;
  margin: 45px 20px;

  input[type='password'] {
    letter-spacing: 0.3em;
  }
  @media screen and (max-width: 800px) {
    width: 90%;
  }
  @media screen and (max-width: 600px) {
    width: 90%;
    margin-bottom: 20px;
    margin-top: 10px;
    font-size: 10px;
  }
`;

export const FormInputContainer = styled.input`
  background: none;
  background-color: white;
  color: ${subColor};
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid ${subColor};

  &:focus {
    outline: none;
  }

  &:focus ~ label {
    ${shrinkLabelStyles}
  }
`;

export const FormInputLabel = styled.label`
  color: ${subColor};
  font-size: 16px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 10px;
  transition: 300ms ease all;
  @media screen and (max-width: 600px) {
    font-size: 10px;
  }

  &.shrink {
    ${shrinkLabelStyles}
  }
`;
